import {useAppSelector} from "@Hooks/selector/useAppSelector";

export default function useGetPassengersName() {
    const {
        passengers,
    } = useAppSelector((state) => (state.checkOrder))

    const getPassengerName = (passengerId: number) => {
        const passengerIndex = passengers.findIndex((passenger) => (
            passenger.passengerId === passengerId
        ))

        const passenger = passengers[passengerIndex]

        const name = passenger.passengerFirstName && passenger.passengerLastName
            ? `${passenger.passengerFirstName} ${passenger.passengerLastName}`
            : `${passengerIndex + 1}. passenger`

        return name
    }

    const getPassengersList = (passengerIds: number[]) => (
        passengerIds.map((passengerId) => (getPassengerName(passengerId))).join(", ")
    )

    return {
        getPassengerName,
        getPassengersList,
    }
}